<template>
    <div class="main-wrapper d-flex justify-center">
        <v-dialog v-model="dialog" width="500" >
            <v-card>
                <v-card-title class="text-h5  lighten-2" style="background: #25ccd5; color:white;">
                Bienvenido de nuevo
                </v-card-title>

                <v-card-text style="padding: 30px 24px 20px;">
                Por favor, completa la información para ver tu resultado de viabilidad y acceder a tu área privada
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
                >
                    Aceptar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
            <v-row class="section_wrapper">
                <v-col cols=12>
                    <v-form ref="form" class="form_wrapper" v-model="valid">
                        <transition :name="animationFade">
                            <div v-if="show">
                                <div  v-if="!showIframe" class="d-flex flex-column flex-sm-row align-center justify-center mb-11">
                                    <h2 class="mb-0 mr-0 mr-sm-6">{{productTitle}}</h2>
                                    <ChangeProductBlock style="flex:initial"/>
                                </div>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'habitual'">
                                    <Habitual></Habitual>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'compra_vivienda_100'">
                                    <Compra_vivienda_100></Compra_vivienda_100>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'cambio_vivienda'">
                                    <Cambio_vivienda></Cambio_vivienda>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === '2avivienda'">
                                    <Segunda_vivienda></Segunda_vivienda>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'liquidez'">
                                    <Liquidez></Liquidez>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'autopromocion'">
                                    <Autopromocion></Autopromocion>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'mejorar'">
                                    <Mejora></Mejora>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'ampliacion'">
                                    <Ampliacion></Ampliacion>
                                </template>
                                <template v-if="preScoring.Vivienda.tipo_vivienda === 'extincion_condominio'">
                                    <Extincion_condominio></Extincion_condominio>
                                </template>
                                
                                <v-row>
                                    <v-col  cols="6" class="d-flex flex-column align-start ">
                                        <v-btn @click="$router.push('view1')" depressed class="blue_button error">Atras</v-btn>
                                    </v-col>
                                    <v-col  cols="6" class="d-flex flex-column align-end">
                                        <v-btn @click="send" :loading="loading" depressed class="blue_button">Siguiente</v-btn>
                                        <p class="steps_info">Paso 2 de 3</p>
                                    </v-col>
                                    
                                </v-row>
                            </div>
                        </transition>
                    </v-form>
                </v-col>
            </v-row>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import rulesMixin from '../mixins/rulesMixin';
    import ChangeProductBlock from '../components/ChangeProductBlock';

    import Habitual from '../components/products/Habitual'
    import Compra_vivienda_100 from '../components/products/Compra_vivienda_100'
    import Cambio_vivienda from '../components/products/Cambio_vivienda'
    import Segunda_vivienda from '../components/products/Segunda_vivienda'
    import Liquidez from '../components/products/Liquidez'
    import Autopromocion from '../components/products/Autopromocion'
    import Mejora from '../components/products/Mejora'
    import Ampliacion from '../components/products/Ampliacion'
    import Extincion_condominio from '../components/products/Extincion_condominio'
    import goTo from 'vuetify/es5/services/goto'

    export default {
        mixins: [rulesMixin],
        components:{
            ChangeProductBlock,
            Habitual,
            Compra_vivienda_100,
            Cambio_vivienda,
            Segunda_vivienda,
            Liquidez,
            Autopromocion,
            Mejora,
            Ampliacion,
            Extincion_condominio
        },
        data() {
            return {
                valid: false,
                data:{},
                show:false,
                animationFade: 'fadeR',
                dialog:false,
            }
        },
        mounted() {
           
           if(this.$route.query.token_id){
               this.SET_SHOW_IFRAME( this.$route.query.iframe);

               setTimeout(() => this.test_prescoring(), 1000); 
            }else{
                this.test_prescoring()
            }
        },
        methods: {
            ...mapMutations([
                'CHANGE_ACTIVE_PRODUCT',
                'SET_ACTIVE_STEP',
                'SET_DATE_KEYS',
                'SET_VALUE',
                'SET_LOADING',
                'SET_PRESCORING_DATA',
                'SET_STEP_WITH_ERROR',
                'SET_SHOW_IFRAME'
            ]),
            ...mapActions([
                'saveProduct'
            ]),
            callChangeActiveProduct(type){
                this.CHANGE_ACTIVE_PRODUCT(type)
            },

            test_prescoring(){
                
                if(this.initalDataLoaded && this.accesibleViews.includes('view2')){
                    this.init();
                    this.show = true;
                    if(this.$route.query.modal_welcome=='true'){
                        this.dialog = true;
                    }
                }else{
                    this.$router.push('/view1');
                }
            },
            init(){
                this.animationFade = (this.activeStep > 2) ? 'fadeL' : 'fadeR'

                this.$refs.form.resetValidation();
                this.SET_ACTIVE_STEP(2);
                this.SET_LOADING(false);

                goTo(0, {offset:60});
                
            },
            send(){
                if(this.$refs.form.validate()){
                    this.SET_LOADING(true);
                    this.saveProduct({token: this.token_id, lead_type:"2"})
                        .then(response => {
                            this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                            this.SET_ACTIVE_STEP(3);
                            this.SET_LOADING(false);
                            this.$router.push({name: 'View3'})
                        })
                        .catch(response=>{
                            console.log('Error: ' , response);
                        })
                }else{
                    setTimeout(() => {
                        const el = document.querySelector(".v-messages.error--text:first-of-type");
                        goTo(el, {offset:120});
                        // CloudFrameWorkInterface.newAlertBox('error', "Error", "Por favor, revisa los campos con errores", 3);
                    }, 200);
                }
            }
        },
        computed: {
            ...mapState([
                'initalDataLoaded',
                'commonVars',
                'preScoring',
                'loading',
                'products',
                'token_id',
                'propertyStatuses',
                'propertyNew',
                'accesibleViews',
                'showIframe'
            ]),
            valueVisible(){
                return (this.preScoring.Vivienda.tipo_vivienda === 'autopromocion') ? false : true;
            },
            productTitle(){
                if(this.preScoring && this.preScoring.Vivienda && this.preScoring.Vivienda.tipo_vivienda){
                    let index = this.products.map(product => product.type).indexOf(this.preScoring.Vivienda.tipo_vivienda);
                    return (index >= 0) ? this.products[index].title : '';
                }else{
                    return '';
                }
            },
            savingsHint(){
                return (this.preScoring.Vivienda.tipo_vivienda != 'compra_vivienda_100') ?
                'Recuerda que cuánto mas aportes, tendrás mejores condiciones y más posibilidades de obtener la financiación' :
                'Si no conoce el valor introduzca una estimación';
            },
            savingsLabel(){
                let label = 'Aportación de dinero que harás a la Compra *';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'autopromocion':
                        label = 'Aportación de dinero que harás a la Operación *';
                        break;
                }
                return label;
            },
            tipoViviendaLabel(){
                let label = 'Valor de compra de la vivienda *';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'mejorar':
                    case 'ampliacion':
                    case 'liquidez':
                    case 'extincion_condominio':
                        label = 'Valor de mercado de tu vivienda *';
                        break;
                }
                return label;
            },
            dateKeysVisible(){
                let visible = false;
                
                if
                (
                    this.preScoring.Vivienda.tipo_vivienda === 'habitual' ||
                    this.preScoring.Vivienda.tipo_vivienda === 'compra_vivienda_100' ||
                    this.preScoring.Vivienda.tipo_vivienda === '2avivienda'
                ){
                    if(this.preScoring.Vivienda.vivienda_nueva === 1){
                        visible = true;
                    }
                }

                return visible;
            },
            propertyNewVisible(){
                let visible = false;
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'habitual':
                    case 'compra_vivienda_100':
                    case '2avivienda':
                        visible = true;
                        break;
                }
                return visible;
            },
            searchingVisible(){
                let visible = false;
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'habitual':
                    case 'compra_vivienda_100':
                    case '2avivienda':
                        visible = true;
                        break;
                }
                return visible;
            },
            pendienteVisible(){
                let visible = false;
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'mejorar':
                    case 'ampliacion':
                    case 'extincion_condominio':
                        visible = true;
                        break;
                }
                return visible;
            },
            liquidezVisible(){
                let visible = false;
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'liquidez':
                    case 'ampliacion':
                    case 'extincion_condominio':
                        visible = true;
                        break;
                }
                return visible;
            },
            liquidezLabel(){ 
                let label = '¿Qué liquidez necesitas? *';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'ampliacion':
                    case 'extincion_condominio':
                        label = '¿Cuánto dinero necesitas? *';
                        break;
                }
                return label;
                
            },
            liquidezHint(){ 
                let hint = '';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'ampliacion':
                        hint = 'Aqui tienes que ingresar el importe total en que quieras ampliar la hipoteca. Liquidez + cancelación de préstamos si quieres, etc.';
                        break;
                    case 'extincion_condominio':
                        hint = 'Aqui tienes que ingresar el importe que le tienes que pagar al actual cotitular.';
                        break;
                }
                return hint;
                
            }
        },
        watch:{
            valid: function(val){
                this.SET_STEP_WITH_ERROR(!val)
            }
        },
        props:['activeAval']
    }
</script>

<style lang="scss" scoped>
    .custom-control-description {
		float: left;
		color: #90A4AE;
		padding-left: 1rem;
		padding-top: 5px;
        a {
            color: var(--helloteca-main);
        }
	}
    .active{
        border: 2px solid red !important;
    }
    
    .main-wrapper{
        padding: 20px;
        box-sizing: border-box;
    }
    .section_wrapper{
        max-width: 1150px;
        .left-text{
            h2{
                font-weight: 500;
                font-size: 1.6rem;
                line-height: 1.9rem;
                margin-bottom: 20px;
            }
            p{
                font-weight: 500;
                font-size: 1.4rem;
                line-height: 1.6rem;
                span{
                    color: var(--helloteca-main);
                    font-weight: bold;
                }
            }
        }
    }
    .form_wrapper{
        h2{
            font-weight: bold;
            color: var(--helloteca-main);
            font-size: 1.7rem;
            line-height: 1.5rem;
        }
    }
    .steps_info{
        font-size: 0.8rem;
        line-height: .9rem;
        color: #999;
        margin-top: 10px;
    }
</style>